<div class="alert alert-danger mt-4" role="alert" *ngIf="errorMessage !== ''">
  {{ errorMessage }}
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="(errorMessage === '') && (serverError === null)">

  <h2>
    Area Configuration
    <span *ngIf="loadingLocationAreas" class="text-secondary">- Loading...</span>
  </h2>

  <p class="text-secondary">
    Set the capacity for different areas of the facility.
  </p>

  <div class="form-group">
    <div class="d-inline">
      <select class="custom-select col-xl-4 col-lg-6 col-md-8"
              id="selectLocation" name="selectLocation"
              [(ngModel)]="selectedLocationId"
              (ngModelChange)="loadLocationAreas()"
              [disabled]="isLoading()"
              [class.disabled]="isLoading()">
        <option *ngIf="locationService.getLocations() === null">Loading...</option>
        <ng-container *ngIf="locationService.getLocations() !== null">
          <option *ngFor="let location of locationService.getLocations()"
                  [ngValue]="location.id">
            {{ location.name }}
          </option>
        </ng-container>
      </select>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-6 col-lg-8">

      <div class="alert" role="alert"
           [class.alert-success]="modalResult.status === CallbackResultStatus.success"
           *ngIf="modalResult !== null">
        {{ modalResult.text }}
      </div>

      <div class="rounded-table-wrapper">
        <table class="table">

          <thead>
            <tr>
              <th>Name</th>
              <th>Capacity</th>
              <th></th>
            </tr>
          </thead>

          <tbody>

            <ng-container *ngIf="locationAreaResultsPresent()">
              <tr *ngFor="let locationArea of locationAreaList">
                <td>{{ locationArea.name }}</td>
                <td>{{ locationArea.capacity }}</td>
                <td class="table-button-cell" style="white-space: nowrap">
                  <div class="float-right">
                    <button class="btn btn-outline-danger btn-sm mr-2"
                            (click)="openRemoveLocationAreaModal(locationArea)">
                      Remove
                    </button>
                    <button class="btn btn-outline-primary btn-sm"
                            (click)="openEditLocationAreaModal(locationArea)">
                      Edit
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="!locationAreaResultsPresent()">
            <tr>
              <td colspan="99">
                {{ loadingLocationAreas ? 'Loading...' : 'No areas' }}
              </td>
            </tr>
            </ng-container>

            <tr *ngIf="!loadingLocationAreas">
              <td colspan="99" class="table-button-cell">
                <button class="btn btn-outline-success btn-block"
                        (click)="openAddLocationAreaModal()">
                  Click to add
                </button>
              </td>
            </tr>

          </tbody>

        </table>
      </div>
    </div>
  </div>

</div>
